import { useState } from 'react';

function HelperBox(props) {
    const [popUp, setPopUp] = useState("none");
    const iconStyle = { marginLeft: "15px", paddingBottom: "6px" };

    function togglePopUp() {
        if (popUp === "none") {
            setPopUp("block");
        }
        else {
            setPopUp("none");
        }
    }

    function popUpOff() {
        setPopUp("none");
    }

    return (
        <div>
            <svg onClick={togglePopUp} className="helpIcon" style={iconStyle} width="20" height="20" viewBox="0 0 300 300" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="8.5" y="8.5" width="283" height="283" rx="52.5" stroke="black" />
                <path d="M128.25 193.212C128.25 179.224 129.948 168.084 133.344 159.792C136.74 151.499 142.933 143.356 151.923 135.364C161.013 127.271 167.057 120.727 170.053 115.731C173.05 110.636 174.548 105.291 174.548 99.6956C174.548 82.8107 166.757 74.3683 151.174 74.3683C143.782 74.3683 137.839 76.6662 133.344 81.2621C128.949 85.7581 126.651 92.0025 126.452 99.9953H83C83.1998 80.9124 89.343 65.9758 101.43 55.1855C113.616 44.3952 130.198 39 151.174 39C172.351 39 188.782 44.1454 200.469 54.4362C212.156 64.627 218 79.0641 218 97.7473C218 106.24 216.102 114.282 212.306 121.876C208.511 129.369 201.868 137.711 192.378 146.903L180.242 158.443C172.65 165.736 168.305 174.279 167.206 184.07L166.607 193.212H128.25ZM123.905 239.22C123.905 232.526 126.152 227.031 130.647 222.735C135.242 218.339 141.085 216.141 148.178 216.141C155.27 216.141 161.063 218.339 165.558 222.735C170.153 227.031 172.451 232.526 172.451 239.22C172.451 245.815 170.203 251.26 165.708 255.556C161.313 259.852 155.469 262 148.178 262C140.886 262 134.992 259.852 130.497 255.556C126.102 251.26 123.905 245.815 123.905 239.22Z" fill="black" />
            </svg>
            <div onClick={popUpOff} className="coverPage" style={{ display: popUp }} >
                <div className="status" style={{ display: popUp }}>
                - Select 1x for regular DPI screens and zoom at 100% or less.<br />
                - Select 2x for high DPI screens or for zoom settings above 100%.<br />
                - Download must be extracted (unzipped) before moving to skins folder.
                </div>
            </div>
        </div>
    )
}

export default HelperBox;